import { initFederation } from '@angular-architects/native-federation';
import { environment } from './environments/environment';
import { getRealmFromUrl } from './app/core/config/get-realm-from-url';

const realm = getRealmFromUrl();
if (!realm) {
  window.location.href = environment.noRealmRedirect;
} else {
  initFederation()
    .then(() => import('./bootstrap'))
    .then(({ bootstrap }) => bootstrap())
    .then(() => {
      const loader = document.getElementById('global-loader');
      if (loader) {
        loader.style.display = 'none';
      }
    })
    .catch((err) => console.error(err));
}
